export const PATHS = {
    main: '/',
    sleepTerritory: '/sleep-territory',
    bestSilk: 'best-silk',
    luxuryArt: 'luxury-art',
    aboutCompany: '/about-company',
    contacts: '/contacts',
    wishlistLegacy: '/wishlist',
    wishlist: '/account/wishlist',
    cart: '/cart',
    account: '/account',
    accountSection: '/account/:section',
    consent: '/consent',
    hotelProducts: '/hotel-products',
    customers: '/customers',
    loyalty: '/loyalty',
    return: '/return',
    deliveryPayment: '/delivery-payment',
    siteMap: '/site-map',

    showcase: '/catalog',
    discounts: '/catalog/discounts',
    admin: '/admin/',
    orders: 'orders',
    products: 'products',
    users: 'users',
    settings: 'settings',
    crpt: 'crpt',
    feedback: 'feedback',

    success: 'success',

    menu: 'menu',

    pillows: '/catalog/pillows',
    blankets: '/catalog/blankets',
    accessories: '/catalog/accessories',
    bedlinens: '/catalog/bedlinens',
    faq: '/faq',
};
